import Box from '@mui/material/Box';
import { Color } from '@/theme/color';
import { Gradient } from './types';

const gradientBg = (gradient: Gradient, color: string): string => {
  switch (gradient) {
    case 'top':
      return `linear-gradient(180deg, ${color} -60%, transparent 110%)`;
    case 'bottom':
      return `linear-gradient(0deg, ${color} -60%, transparent 110%)`;
    case 'left':
      return `linear-gradient(90deg, ${color} -60%, transparent 110%)`;
    case 'right':
      return `linear-gradient(270deg, ${color} -60%, transparent 110%)`;
    case 'none':
    default:
      return color;
  }
};

export interface BackgroundProps {
  className?: string;
  children?: React.ReactNode;
  color?: Color;
  src?: string;
  position?: string;
  gradient?: Gradient;
}

export const Background = ({
  className,
  children,
  color,
  gradient = 'none',
  position = 'center',
  src,
}: BackgroundProps) => {
  const bg = gradientBg(gradient, color || '#ffffff');
  return (
    <Box
      className={className}
      sx={{
        background: bg,
        ...(src && {
          backgroundImage: `url(${src})`,
          backgroundSize: 'cover',
          backgroundPosition: position,
          backgroundRepeat: 'no-repeat',
        }),
      }}
    >
      {children}
    </Box>
  );
};

Background.displayName = 'Background';

export default Background;
